<template>
  <v-dialog
    v-model="dialog"
    width="500"
  >
    <template v-slot:activator="{ on }">
      <v-btn
        @click="save()"
        color='success'
        :disabled="!isDispatchValid()"
        :loading="processingSave"
        persistent
      >
        <v-icon small
                class="mr-1"
        >
          mdi-content-save
        </v-icon>
        Salvar
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="grey lighten-3">
        <v-icon medium class="mr-2">mdi-file-check</v-icon>
        <span class="title font-weight-regular">Salvar Documento</span>
      </v-card-title>
      <v-card-text>
        <v-layout column class="text-xs-center">
          <v-flex>
            <div xs12>
              <img src="/static/images/settings/file-save-update.png" width="96">
            </div>
            <div xs12>
              <span class="grey--text text--darken-2">Seu modelo de despacho foi salvo.</span>
            </div>
            <div xs12>
              <span class="grey--text text--darken-2">Deseja sair do modo de edição?</span>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="justify-space-around">
        <v-btn
          color="grey darken-2"
          flat @click="dialog = false">
          Continuar editando
        </v-btn>
        <v-btn color="blue darken-1 white--text"
               @click="$router.push('/configuracao/despachos/lista')">
          Sair da edição
        </v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>

  import DispatchService from "@/services/system/DispatchService";
  import {isEmpty, map} from 'lodash'

  export default {
    name: 'SaveDispatchDialog',
    props: ['dispatch'],
    data() {
      return {
        dialog: false,
        processingSave: false,
        isEmpty
      };
    },
    methods: {
      save() {
        this.processingSave = true;
        const payload = {
          id: this.dispatch.id,
          title: this.dispatch.title,
          administrativeUnitIds: map(this.dispatch.administrativeUnits, (au) => {
            return au.id
          }),
          text: this.dispatch.text,
        };
        DispatchService
          .createOrUpdate(payload)
          .then((res) => {
            this.dialog = true;
            if (res.data.id !== undefined) {
              this.dispatch.id = res.data.id;
            }
          })
          .catch((err) => {
            this.$store.dispatch('toggleSnackbar', {
              show: true,
              color: 'error',
              message: err.join(', '),
              button: {show: true, text: 'Fechar', message: ''},
              timeout: 6000,
            });
          })
          .finally(() => {
            this.processingSave = false
          })
      },
      isDispatchValid() {
        if (isEmpty(this.dispatch)) return false;
        return !this.isEmpty(this.dispatch.title) &&
          !this.isEmpty(this.dispatch.administrativeUnits) &&
          !this.isEmpty(this.dispatch.text)
      },
    },
  };
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/settings/dispatches/SaveDispatchDialog.vue